import {
    PsHttpService,
    type PatSnapCommonResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { isUserLogin } from '@eureka/utils/account';

export interface PatentSignatureItem {
    date: string
    expire: number
    from: string
    object_key: string
    share_id: string
    signature: string
    version: string
}

export interface PatentSignatureApi {
    getPatentSignature(
        data: { patent_id: string[] },
    ): Promise<Record<string, PatentSignatureItem>>;
}

export const PatentSignatureApi = Symbol('PatentSignatureApi');

@injectable()
export class PatentSignatureApiImpl extends PsHttpService implements PatentSignatureApi {
    get baseUrl() {
        return `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-eurekals-api/eurekals_agent/1.0`
    }

    get options() {
        return {
            baseURL: this.baseUrl,
        };
    }

    async getPatentSignature(data: { patent_id: string[] }) {
        const isLogin = await isUserLogin()
        const base = isLogin ? '' : '/guest'
        return this.post<PatSnapCommonResponseData<Record<string, PatentSignatureItem>>>({
            url: `${base}/patent/signature`,
            data,
        }).then((res) => {
            return res.data as unknown as Record<string, PatentSignatureItem>;
        });
    }
}
